import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { Typography } from '@material-ui/core'
import { Form, useFormik, FormikProvider } from 'formik'

import IosSwitchFormik from 'app/components/IosSwitchFormik'

import useAction from 'app/main/messages/timeline/Action/useAction'

const ToggleApplyWebHistory = (props) => {
  const { id, value = false } = props
  const { formatMessage } = useIntl()

  const {
    state: { isToggleHistoryError },
    updateApplyHistory,
    handleIsToggleHistoryError,
  } = useAction()

  const formik = useFormik({
    initialValues: {
      applyWebHistory: value,
    },
  })

  const handleToggle = async (value) => {
    await updateApplyHistory(id, value)
  }

  useEffect(() => {
    if (isToggleHistoryError) {
      formik.setFieldValue('applyWebHistory', value)
    } else return

    return () => handleIsToggleHistoryError()
  })

  return (
    <FormikProvider value={formik}>
      <Form>
        <div className="flex space-x-3 items-center">
          <IosSwitchFormik
            name="applyWebHistory"
            onChange={(value) => handleToggle(value)}
            inputProps={{
              'data-testid': `applyWebHistory`,
            }}
          />
          <Typography className="text-grey-400 font-normal text-14">
            {formatMessage({
              id: 'timeline.detail.message.apply.history.toggle',
            })}
          </Typography>
        </div>
      </Form>
    </FormikProvider>
  )
}

ToggleApplyWebHistory.propTypes = {
  id: PropTypes.number,
  value: PropTypes.bool,
}

export default ToggleApplyWebHistory
